/* UI only. Shopify and Kaching retain control of purchasing, discounts and gifts. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ref-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('[data-ref-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-ref-thumb]')];
      let current = 0;
      function show(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== current;
          slide.classList.toggle('is-active', i === current);
          if (i !== current) slide.querySelectorAll('video').forEach(v => v.pause());
        });
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === current);
          thumb.setAttribute('aria-pressed', String(i === current));
        });
        const thumb = thumbs[current], rail = gallery.querySelector('.ref-thumbnails');
        if (thumb && rail) rail.scrollTo({left:thumb.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + thumb.clientWidth / 2, behavior:'smooth'});
      }
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      gallery.querySelector('[data-ref-prev]')?.addEventListener('click', () => show(current - 1));
      gallery.querySelector('[data-ref-next]')?.addEventListener('click', () => show(current + 1));
      gallery.querySelector('.ref-gallery-stage')?.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); show(current + (e.key === 'ArrowRight' ? 1 : -1));}
      });
      let startX;
      gallery.addEventListener('touchstart', e => {startX=e.changedTouches[0].clientX;}, {passive:true});
      gallery.addEventListener('touchend', e => {
        if (e.target.closest('video,button,.ref-thumbnails')) return;
        const delta=e.changedTouches[0].clientX-startX;
        if (Math.abs(delta)>50) show(current+(delta<0?1:-1));
      }, {passive:true});
      const dialog=gallery.closest('[data-ref-product]')?.querySelector('[data-ref-lightbox]');
      gallery.querySelector('[data-ref-zoom]')?.addEventListener('click', () => {
        const source=slides[current]?.querySelector('img');
        if (!source || !dialog) return;
        dialog.querySelector('img').src=source.currentSrc || source.src;
        dialog.querySelector('img').alt=source.alt;
        dialog.showModal();
      });
      dialog?.querySelector('[data-ref-close]')?.addEventListener('click',()=>dialog.close());
      dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
    });
    root.querySelectorAll('[data-ref-product]').forEach(section => {
      if(section.dataset.ready) return;
      section.dataset.ready='true';
      const selector=section.querySelector('[data-ref-variant]');
      const nativeButtonLabel=section.querySelector('.main-atc__label__text')?.textContent;
      const idInput=section.querySelector('form[action*="/cart/add"] [name="id"]');
      selector?.addEventListener('change',()=>{
        const option=selector.selectedOptions[0];
        if(idInput){idInput.value=selector.value;idInput.dispatchEvent(new Event('change',{bubbles:true}));}
        const price=section.querySelector('[data-ref-price]');
        if(price){price.replaceChildren(document.createTextNode(option.dataset.price+' '));if(option.dataset.onSale==='true'){const s=document.createElement('s');s.textContent=option.dataset.compare;price.append(s);}}
        const submit=section.querySelector('[name="add"]');
        if(submit){submit.disabled=option.dataset.available!=='true';const label=submit.querySelector('.main-atc__label__text');if(label)label.textContent=submit.disabled?'Sold out':nativeButtonLabel;}
        if(location.pathname.includes('/products/')){const url=new URL(location.href);url.searchParams.set('variant',selector.value);history.replaceState({},'',url);}
      });
      // Sync changes made by an app without intercepting its cart requests.
      idInput?.addEventListener('change',()=>{if(selector && [...selector.options].some(o=>o.value===idInput.value)) selector.value=idInput.value;});
      const sticky=section.querySelector('[data-ref-sticky]'), buy=section.querySelector('.product-form') || section.querySelector('.ref-button');
      if(sticky && buy){
        const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting || entries[0].boundingClientRect.top>0;},{threshold:0});
        observer.observe(buy);
        section.querySelector('[data-ref-scroll-buy]')?.addEventListener('click',()=>{(section.querySelector('.ref-app-slot')?.children.length?section.querySelector('.ref-app-slot'):buy).scrollIntoView({behavior:'smooth',block:'center'});});
        section.addEventListener('ref:cleanup',()=>observer.disconnect(),{once:true});
      }
    });
    root.querySelectorAll('.ref-reviews-section').forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='true';
      const track=section.querySelector('[data-ref-reviews]');
      const move=dir=>track.scrollBy({left:dir*(track.clientWidth+15),behavior:'smooth'});
      section.querySelector('[data-ref-review-prev]')?.addEventListener('click',()=>move(-1));
      section.querySelector('[data-ref-review-next]')?.addEventListener('click',()=>move(1));
      track?.addEventListener('scroll',()=>{const i=Math.round(track.scrollLeft/(track.clientWidth+15));section.querySelector('.ref-review-dots').textContent=[...track.children].map((_,n)=>n===i?'●':'○').join(' ');},{passive:true});
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-ref-product]').forEach(s=>s.dispatchEvent(new Event('ref:cleanup'))));
})();
